import type { FeatureData } from "@/types/content";
import type EditorPolygonController from "../Editors/EditorPolygonController";
import type MapboxViewer from "../../MapboxViewer";
import type EditorMeasureAreaController from "../Editors/EditorMeasureAreaController";
import type EditorMeasureLengthController from "../Editors/EditorMeasureLengthController";
import type EditorBuildingController from "../Editors/EditorBuildingController";
export class MapboxCustomObject {
  protected _content: FeatureData;
  protected _contentId: string = "";
  protected _mapboxViewer: MapboxViewer;
  protected _editor:
    | EditorPolygonController
    | EditorBuildingController
    | EditorMeasureLengthController
    | EditorMeasureAreaController
    | null = null;

  constructor(mapboxViewer: MapboxViewer, content: FeatureData) {
    this._mapboxViewer = mapboxViewer;
    this._content = content;
    this._contentId = `${content.id}`;
  }

  set content(content: FeatureData) {
    this._content = content;
  }

  get content() {
    return this._content;
  }

  set contentId(contentId: string) {
    this._contentId = contentId;
  }

  get contentId(): string {
    return this._contentId;
  }

  get editor() {
    return this._editor;
  }

  set editor(
    editor:
      | EditorPolygonController
      | EditorBuildingController
      | EditorMeasureLengthController
      | EditorMeasureAreaController
      | null
  ) {
    this._editor = editor;
  }
  focusOn() {
    console.log("focusOn");
  }

  setHighlight() {
    console.log("setHighlight");
  }

  setSelected() {
    console.log("setSelected");
  }

  setUnhighlight() {
    console.log("setUnhighlight");
  }
}
